import React from "react";
import styles from "./ErrorPage.module.css";
import Footer from "./Footer";
import { colors } from "../utils/colors";
import Button from "./Button/Button";
import { useTranslation } from "react-i18next";

const ErrorPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.pageWrapper}>
      <div className={styles.errorContainer}>
        <video autoPlay loop muted className={styles.backgroundVideo}>
          <source src="/error_animation.mp4" type="video/mp4" />
        </video>

        <div className={styles.content}>
          <div className={styles.messageWrapper}>
            <div className={styles.messageBox}>
              <h1 style={{ color: colors.navBarGreen }}>{t("error.title")}</h1>
              <p>{t("error.line1")}</p>
              <p>{t("error.line2")}</p>
              <p>{t("error.line3")}</p>
              <p>{t("error.line4")}</p>
              <p>{t("error.line5")}</p>
            </div>
            <Button
              buttonStyles={{
                padding: "16px",
                backgroundColor: colors.navBarGreen
              }}
              onClick={() => (window.location.href = "/")}
              label={t("error.backButton")}
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ErrorPage;
